import { Col } from '@/components/grid/grid-component';
import { GoCircle } from 'react-icons/go';
import styled from 'styled-components';

const StatusCircle = styled(GoCircle)`
  margin-left: 8px;
`;

const ImageSection = styled(Col)`
  display: flex;
  flex-direction: column;
`;

const Spacer = styled.div`
  height: 16px;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
`;

const Bumper = styled.div`
  height: 24px;
`;

const CompanyFormStyle = {
  ImageSection,
  StatusCircle,
  Spacer,
  Bumper,
};

export default CompanyFormStyle;
